import { Pipe, PipeTransform } from '@angular/core';
import { RegressionDropdown } from '../services/drop.down.service';

@Pipe({
    name: 'filterRegressionMetric',
    standalone: true
})
export class FilterRegressionMetricPipe implements PipeTransform {

    public transform(value: RegressionDropdown[], searchValue: string): RegressionDropdown[] {
        if (!searchValue || searchValue.length < 3) {
            return value;
        }
        const pattern = new RegExp('\\b' + searchValue.toLocaleLowerCase());
        return value.filter((metric: RegressionDropdown) => pattern.test(metric.metricTitle.toLocaleLowerCase()));
    }

}
